module.exports = __webpack_public_path__ + "c8f7e70ec313554479d875fda4442465.svg";